export default __webpack_public_path__ + "static/banner-back-90fe25fa3324e9bac5bece67d60d2c02.webp";